import { Modal as MantineModal } from '@mantine/core'
import clsx from 'clsx'
import ModalContent from './ModalContent'
import type { ModalProps } from './types'

export default function Modal({
	isShow,
	title,
	footer,
	header,
	children,
	backdrop = true,
	onClick,
	onClose,
	className,
	...props
}: ModalProps) {
	return (
		<MantineModal
			opened={isShow}
			onClose={onClose!}
			withCloseButton={false}
			closeOnClickOutside={backdrop !== 'static'}
			overlayProps={{
				className: 'jk-modal-backdrop',
				transitionProps: {
					transition: 'fade',
				},
			}}
			centered
			fullScreen
			trapFocus={false}
			className={clsx(className, 'jk-modal')}
			{...props}
		>
			<ModalContent isShow={isShow} title={title} footer={footer} header={header}>
				{children}
			</ModalContent>
		</MantineModal>
	)
}
